import { render, staticRenderFns } from "./FilterFamily.vue?vue&type=template&id=930412ba&"
import script from "./FilterFamily.vue?vue&type=script&lang=js&"
export * from "./FilterFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports